import React, { useRef, useState, useEffect, useContext } from "react";
import {
  Card,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  Container,
  Link,
  Modal,
  useTheme,
  Tabs,
  Tab,
} from "@mui/material";
import { Form, Formik } from "formik";
import AuthAPI, { SignInRequest } from "../../apis/AuthAPI";

import { useNavigate, useLocation } from "react-router";
import * as yup from "yup";
import { Spinner } from "react-bootstrap";
import SessionStorageService from "../../services/StorageService";
import { toast } from "react-toastify";
import { ConstantAPISContext } from "../../context/ConstantAPISContext";
import Recaptcha from "../../components/Recaptcha";
import TcTelefonKullaniciVarMi from "../../components/OB/popups/sifremi-unuttum-popup";
import KullaniciSifreDegistir, {
  KullaniciSifreDegistirRequest,
} from "../../apis/OB/SaveApi/KullaniciSifreDegistir";
import {
  EDEVLET_LINK_PARTIAL_1,
  EDEVLET_LINK_PARTIAL_2,
} from "../../config/environment";
import { CustomButton } from "../../components/OB/SearchComponent";
import LoginSmsDogrulama from "../../components/OB/popups/login-sms-dogrulama-popup";
import { ThemeContext } from "../../context/themeProviderContext";

function Login(props: any) {
  const user = SessionStorageService.getUserInfo();
  const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);
  const [smsControlled, setSmsControlled] = useState(false);
  const [kullaniciKodu, setKullaniciKodu] = useState("");
  const [vergiNo, setVergiNo] = useState("");
  const [selectedTab, setSelectedTab] = useState(0); // 0: TC, 1: Vergi
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [passwordChangeCompleted, setPasswordChangeCompleted] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loginTab, setLoginTab] = useState<"tc" | "vergi">("tc");
  const COUNTDOWN_DURATION = 3;

  const [smsPopupOpen, setSmsPopupOpen] = useState(false);
  const [smsPopupData, setSmsPopupData] = useState<any>(null);
  const { loginTelKontrol }: any = useContext(ThemeContext);


  const location = useLocation();
  // SifreYenile uyarısı
  useEffect(() => {
    if (location.state?.passwordChanged) {
      setTimeout(() => {
        toast.success("Şifreniz başarıyla değiştirildi. Lütfen yeni şifrenizle giriş yapınız.");
      }, 100);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, []);

  const loginValidationSchema = () => {
    const base = yup.object({
      tcKimlikNo:
        loginTab === "tc"
          ? yup
            .string()
            .required("T.C. Kimlik Numarası zorunludur")
            .max(11, "T.C. Kimlik Numarası en fazla 11 karakter olabilir.")
          : yup.string().nullable(),
      vergiNo:
        loginTab === "vergi"
          ? yup
            .string()
            .required("Vergi Numarası zorunludur")
            .max(11, "Vergi Numarası en fazla 11 karakter olabilir.")
          : yup.string().nullable(),
      sifre: yup.string().required("Şifre zorunludur"),
    });

    // Eğer şifre değiştirme modal'ı açık ve smsControlled ise, yeni şifre doğrulamasını ekle
    if (smsControlled) {
      return base.concat(
        yup.object({
          newPassword: yup
            .string()
            .min(8, "Şifre en az 8 karakter olmalıdır")
            .matches(/[A-Z]/, "En az bir büyük harf içermelidir")
            .matches(/[0-9]/, "En az bir rakam içermelidir")
            .matches(
              /[!@#$%^&*(),.?":{}|<>]/,
              "En az bir noktalama işareti içermelidir"
            )
            .required("Şifre zorunludur"),
          newPasswordConfirm: yup
            .string()
            .oneOf([yup.ref("newPassword"), null], "Şifreler uyuşmuyor !")
            .required("Şifre tekrar zorunludur"),
        })
      );
    }

    return base;
  };
  const theme = useTheme();

  const navigate = useNavigate();
  const recaptchaTokenRef: any = useRef();
  const [handleRecaptchaChange, setHandleRecaptchaChange] = useState(false);

  function generateRandomFiveDigitNumber(): number {
    return Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
  }
  const handlePasswordChange = async (
    formValues: { newPassword: string; newPasswordConfirm: string },
    afterSuccessClear?: () => void
  ) => {
    const { newPassword } = formValues;

    // Invisible reCAPTCHA’yı çalıştır (execute)
    let token: string | null = null;
    try {
      token = await recaptchaTokenRef.current?.handleSubmit();
    } catch {
      token = null;
    }

    // Token geldi mi?
    if (!token) {
      setIsError(true);
      setErrorMessage("Lütfen recaptcha doğrulamasını geçin.");
      return;
    }

    console.log({
      kullaniciKodu: kullaniciKodu,
      vergiNo: vergiNo,
      selectedTab: selectedTab,
      sifre: newPassword,
    });

    // Seçilen tab'a göre request oluştur
    let request;
    if (selectedTab === 0) {
      // TC Kimlik No ile şifre değiştirme
      request = new KullaniciSifreDegistirRequest(
        newPassword,
        kullaniciKodu,
        undefined
      );
    } else {
      // Vergi No ile şifre değiştirme
      request = new KullaniciSifreDegistirRequest(
        newPassword,
        undefined,
        vergiNo
      );
    }

    KullaniciSifreDegistir.saveKullaniciSifreDegistirSave(request)
      .then((response) => {
        if (response.data.sonuc === 0) {
          setPasswordChangeCompleted(true);
          setIsError(false); // Hata durumunu sıfırla
          setErrorMessage(""); // Hata mesajını temizle
          setKullaniciKodu("");
          if (afterSuccessClear) {
            afterSuccessClear();
          }
          setShowForgotPasswordPopup(false); // Popup'ı kapat
          toast.success("Şifreniz başarılı bir şekilde değiştirilmiştir.");
          setSmsControlled(false);
        } else {
          setIsError(true);
          setErrorMessage(response.data.sonucAciklama);
        }
      })

      .catch((error) => {
        // Hata durumu
        setIsError(true);
        setErrorMessage(
          error.response?.data?.message || "Bilinmeyen bir hata oluştu."
        );
      })
      .finally(() => {
        // Recaptcha'yı sıfırla
        recaptchaTokenRef.current?.reset();
      });
  };

  const { setKullaniciVarmi } = useContext(ConstantAPISContext);

  const [countdown, setCountdown] = useState(-1);

  // Countdown için useEffect: countdown > 0 iken her saniye bir azaltır, countdown = 0 ise buton aktif
  useEffect(() => {
    if (countdown < 0) return;
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 0) {
          clearInterval(timer);
          return -1;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <Formik
      initialValues={{
        tcKimlikNo: "",
        vergiNo: "",
        sifre: "",
        newPassword: "",
        newPasswordConfirm: "",
      }}
      validationSchema={loginValidationSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setSubmitting }) => {
        if (countdown > 0) return;

        if (loginTelKontrol == "E") {
          setSubmitting(true);
          let request = new SignInRequest(
            loginTab === "tc" ? values.tcKimlikNo : null,
            loginTab === "vergi" ? values.vergiNo : null,
            values.sifre,
            "OB",
            ""
          );
          const response = await AuthAPI.LoginSmsControl(request);
          if (response.success) {
            setSmsPopupOpen(true);
            setSmsPopupData({
              tcKimlikNo: loginTab === "tc" ? values.tcKimlikNo : undefined,
              vergiNo: loginTab === "vergi" ? values.vergiNo : undefined,
              password: values.sifre,
              formValues: values,
              setSubmitting: setSubmitting,
            });
            setSubmitting(false);
          }
        } else {
          const captchaToken = await recaptchaTokenRef.current?.handleSubmit();
          setSubmitting(true);
          let request = new SignInRequest(
            loginTab === "tc" ? values.tcKimlikNo : null,
            loginTab === "vergi" ? values.vergiNo : null,
            values.sifre,
            "OB",
            captchaToken
          );
          AuthAPI.signIn(request)
            .then((response) => {
              if (response.sonuc === 0) {
                setKullaniciVarmi(true);
                toast.success("Giriş işlemi başarılı");
                navigate("/");
              } else if (response.sonuc === 5) {
                recaptchaTokenRef.current?.reset();
                toast.error(
                  "Beklenmedik bir hata oluştu lütfen daha sonra tekrar deneyiniz."
                );
              } else {
                recaptchaTokenRef.current?.reset();
                toast.error(response.sonucAciklama);
              }
            })
            .catch((error) => {
              //toast.error("Bir hata oluştu daha sonra tekrar deneyiniz.")

              recaptchaTokenRef.current?.reset();
            })
            .finally(() => {
              setSubmitting(false);
              setCountdown(COUNTDOWN_DURATION);
            });
        }
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        isSubmitting,
        resetForm,
        validateForm,
        setTouched,
      }) => (
        <Form
          style={{
            margin: 0,
            backgroundImage: `url(/sampasBelediyesi.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          onSubmit={handleSubmit}
        >
          <Container
            maxWidth="sm"
            sx={{
              display: "flex",
              height: "100vh",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Card sx={{ opacity: 1, p: 4, width: "100%", boxShadow: 3 }}>
              <Tabs
                value={loginTab}
                onChange={(_, newTab) => {
                  setLoginTab(newTab);
                  // formu initialValues’a sıfırla
                  resetForm();
                }}
                sx={{ mb: 2 }}
              >
                <Tab label="T.C. Kimlik No ile Giriş" value="tc" />
                <Tab label="Vergi No ile Giriş" value="vergi" />
              </Tabs>
              {loginTab === "tc" && (
                <TextField
                  fullWidth
                  name="tcKimlikNo"
                  size="small"
                  label="T.C. Kimlik Numaranız"
                  variant="outlined"
                  inputProps={{ maxLength: 11 }}
                  margin="normal"
                  value={values.tcKimlikNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.tcKimlikNo && Boolean(errors.tcKimlikNo)}
                  helperText={touched.tcKimlikNo && errors.tcKimlikNo}
                />
              )}
              {loginTab === "vergi" && (
                <TextField
                  fullWidth
                  name="vergiNo"
                  size="small"
                  label="Vergi Numaranız"
                  variant="outlined"
                  inputProps={{ maxLength: 11 }}
                  margin="normal"
                  value={values.vergiNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.vergiNo && Boolean(errors.vergiNo)}
                  helperText={touched.vergiNo && errors.vergiNo}
                />
              )}
              <TextField
                fullWidth
                name="sifre"
                size="small"
                label="Şifreniz"
                type="password"
                variant="outlined"
                margin="normal"
                value={values.sifre}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.sifre && Boolean(errors.sifre)}
                helperText={touched.sifre && errors.sifre}
              />
              <div className="d-flex justify-content-sm-start g-recaptcha">
                <Recaptcha
                  ref={recaptchaTokenRef}
                  changeHandleRecaptcha={(handleCaptcha: any) =>
                    setHandleRecaptchaChange(handleCaptcha)
                  }
                />
              </div>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  mb: 2,
                  mt: 4,
                }}
              >
                {/* <Button type='submit' color="primary" variant='contained' disabled={countdown > 0 || isSubmitting}  sx={{ position: 'relative', overflow: 'hidden' }}>
                  {countdown > 0 ? countdown : (isSubmitting ? <Spinner color='white' /> : "Giriş Yap")}
                </Button> */}
                <CustomButton
                  color="primary"
                  type="submit"
                  className="text-white"
                  disabled={countdown >= 0 || isSubmitting}
                  sx={{ position: "relative", overflow: "hidden" }}
                >
                  <span style={{ position: "relative", zIndex: 1 }}>
                    {isSubmitting ? <Spinner color="white" /> : "Giriş Yap"}
                  </span>

                  {/* Eğer countdown > 0 ise soldan sağa dolan overlay */}
                  {countdown >= 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: `${
                          ((COUNTDOWN_DURATION - countdown) /
                            COUNTDOWN_DURATION) *
                          100
                        }%`,
                        height: "100%",
                        backgroundColor: theme.palette.primary.main,
                        transition: "width 1s linear",
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </CustomButton>
                <Button
                  variant="outlined"
                  color="warning"
                  onClick={() => {
                    setIsError(false);
                    setErrorMessage("");
                    resetForm({
                      values: {
                        ...values,
                        newPassword: "",
                        newPasswordConfirm: "",
                      },
                    });
                    recaptchaTokenRef.current?.reset();
                    setSmsControlled(false);
                    setKullaniciKodu("");
                    setVergiNo("");
                    setSelectedTab(0);
                    setShowForgotPasswordPopup(true);
                  }}
                >
                  Şifremi unuttum?
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => navigate("/")}
                  type="button"
                  sx={{ flexGrow: 1, mb: 2 }}
                >
                  Anasayfa
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => {
                    const randomValue = Math.random()
                      .toString(36)
                      .substring(2, 12);

                    const fullLink = `${EDEVLET_LINK_PARTIAL_1!}&state=${randomValue}${EDEVLET_LINK_PARTIAL_2!}`;

                    window.location.href = fullLink;
                  }}
                  type="button"
                  color="error"
                  sx={{ flexGrow: 1 }}
                >
                  E-Devlet Girişi
                </Button>
              </Box>
              <Typography variant="body2" sx={{ mt: 2, textAlign: "center" }}>
                Üye değil misiniz?{" "}
                <Link
                  onClick={() => navigate("/uyelik-kayit")}
                  sx={{ cursor: "pointer" }}
                >
                  Hemen Kaydolun
                </Link>
                .
              </Typography>
            </Card>
          </Container>
          <Modal
            open={showForgotPasswordPopup}
            onClose={() => {
              setShowForgotPasswordPopup(false);
              setIsError(false);
              setErrorMessage("");
              resetForm({
                values: { ...values, newPassword: "", newPasswordConfirm: "" },
              });
              recaptchaTokenRef.current?.reset();
              setSmsControlled(false);
            }}
            aria-labelledby="forgot-password-modal"
            aria-describedby="forgot-password-form"
          >
            <Box sx={{ ...modalStyle, width: 400 }}>
              {smsControlled ? (
                <Box
                  id="forgot-password-form"
                  className="d-flex flex-column gap-3"
                >
                  <Typography variant="h6" component="h2">
                    Yeni Şifre
                  </Typography>
                  <TextField
                    name="newPassword"
                    label="Yeni Şifre"
                    type="password"
                    size="small"
                    value={values.newPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.newPassword && Boolean(errors.newPassword)}
                    helperText={touched.newPassword && errors.newPassword}
                  />
                  <TextField
                    name="newPasswordConfirm"
                    label="Yeni Şifre Tekrar"
                    type="password"
                    size="small"
                    value={values.newPasswordConfirm}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.newPasswordConfirm &&
                      Boolean(errors.newPasswordConfirm)
                    }
                    helperText={
                      touched.newPasswordConfirm && errors.newPasswordConfirm
                    }
                  />
                  <div className="d-flex justify-content-sm-start g-recaptcha">
                    <Recaptcha
                      ref={recaptchaTokenRef}
                      changeHandleRecaptcha={(handleCaptcha: any) =>
                        setHandleRecaptchaChange(handleCaptcha)
                      }
                    />
                  </div>
                  {isError && (
                    <Typography variant="body2" color="error">
                      {errorMessage}
                    </Typography>
                  )}
                  <Button
                    onClick={async () => {
                      const validationErrors = await validateForm();
                      setTouched({
                        ...touched,
                        newPassword: true,
                        newPasswordConfirm: true,
                      });
                      if (
                        validationErrors.newPassword ||
                        validationErrors.newPasswordConfirm
                      ) {
                        return;
                      }
                      handlePasswordChange(values, () => {
                        resetForm({
                          values: {
                            ...values,
                            newPassword: "",
                            newPasswordConfirm: "",
                          },
                        });
                        recaptchaTokenRef.current?.reset();
                        setSmsControlled(false);
                      });
                    }}
                    color="primary"
                  >
                    Şifre Değiştir
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => setShowForgotPasswordPopup(false)}
                  >
                    Geri
                  </Button>
                </Box>
              ) : (
                <TcTelefonKullaniciVarMi
                  smsControlledSet={setSmsControlled}
                  tcKimlikNoSet={(value: any) => {
                    if (value) {
                      setKullaniciKodu(value);
                      setSelectedTab(0); // TC Kimlik No
                    } else {
                      setKullaniciKodu("");
                      setSelectedTab(1); // Vergi No
                    }
                  }}
                  vergiNoSet={(value: any) => {
                    if (value) {
                      setVergiNo(value);
                      setSelectedTab(1); // Vergi No
                    } else {
                      setVergiNo("");
                      setSelectedTab(0); // TC Kimlik No
                    }
                  }}
                />
              )}
            </Box>
          </Modal>
          <LoginSmsDogrulama
            open={smsPopupOpen}
            onClose={() => {
              setSmsPopupOpen(false);
              setSmsPopupData(null);
              setCountdown(-1);
              setSmsControlled(false);
              recaptchaTokenRef.current?.reset();
              // Form submitting'i false yap
              if (smsPopupData?.setSubmitting) {
                smsPopupData.setSubmitting(false);
              }
              setCountdown(COUNTDOWN_DURATION);
            }}
            tcKimlikNo={smsPopupData?.tcKimlikNo}
            vergiNo={smsPopupData?.vergiNo}
            recaptchaRef={recaptchaTokenRef} // Ana reCAPTCHA ref'ini geçir
            onSmsSuccess={async (smsResponse) => {
              // SMS başarılı olunca login işlemini gerçekleştir
              const values = smsPopupData?.formValues;
              const setSubmitting = smsPopupData?.setSubmitting;

              if (!values || !setSubmitting) return;

              try {
                // reCAPTCHA token'ını al
                setSubmitting(true); // Loading durumunu göster

                // reCAPTCHA token'ını YENİDEN al - çünkü SMS popup'ta kullanıldı
                recaptchaTokenRef.current?.reset();
                await new Promise((resolve) => setTimeout(resolve, 100)); // Kısa bekle
                const captchaToken =
                  await recaptchaTokenRef.current?.handleSubmit();

                let request = new SignInRequest(
                  loginTab === "tc" ? values.tcKimlikNo : null,
                  loginTab === "vergi" ? values.vergiNo : null,
                  values.sifre,
                  "OB",
                  captchaToken
                );

                const response = await AuthAPI.signIn(request);

                if (response.sonuc === 0) {
                  setKullaniciVarmi(true);
                  toast.success("Giriş işlemi başarılı");
                  navigate("/");
                } else if (response.sonuc === 5) {
                  recaptchaTokenRef.current?.reset();
                  toast.error(
                    "Beklenmedik bir hata oluştu lütfen daha sonra tekrar deneyiniz."
                  );
                } else {
                  recaptchaTokenRef.current?.reset();
                  toast.error(response.sonucAciklama);
                }
              } catch (error) {
                //toast.error("Bir hata oluştu daha sonra tekrar deneyiniz.");
                recaptchaTokenRef.current?.reset();
              } finally {
                setSubmitting(false);
                setCountdown(COUNTDOWN_DURATION);
                setSmsPopupOpen(false);
              }
            }}
          />
        </Form>
      )}
    </Formik>
  );
}

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default Login;
